import { useEffect, useRef, useState } from 'react';
import { Info } from 'lucide-react';

const SoftLaunchBanner = () => {
  const scrollRef = useRef(null);
  const containerRef = useRef(null);
  const [shouldAnimate, setShouldAnimate] = useState(true);

  useEffect(() => {
    const checkOverflow = () => {
      if (scrollRef.current && containerRef.current) {
        const scrollWidth = scrollRef.current.scrollWidth;
        const containerWidth = containerRef.current.clientWidth;
        
        // Set animation state based on content comparison OR force animation
        setShouldAnimate(true); // Always animate regardless of width
      }
    };

    // Initial check
    checkOverflow();
    
    // Check on resize
    window.addEventListener('resize', checkOverflow);
    
    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, []);

  return (
    <div className="bg-primary-50 border-y border-primary-200">
      <div
        ref={containerRef}
        className="container mx-auto px-4 py-2 md:py-3 relative overflow-hidden"
      >
        <div className="flex items-center">
          <div className="flex-shrink-0 mr-3">
            <Info className="w-4 h-4 md:w-5 md:h-5 text-primary" />
          </div>
          <div className="overflow-hidden">
            <div
              ref={scrollRef}
              className={`whitespace-nowrap text-sm md:text-base text-primary ${
                shouldAnimate ? 'animate-marquee' : ''
              }`}
            >
              🚀 SportsFuture is Growing with Apertum Blockchain! OpenPlaza LinkHub now live – more Web3.0 tools coming soon. Roadmap = Guideline, not set in stone – we evolve with Web3.0!
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoftLaunchBanner;